var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLobbyCreate = function SvgLobbyCreate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lobby_create_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.475 0H7.525A7.525 7.525 0 0 0 0 7.525v12.95A7.525 7.525 0 0 0 7.525 28h12.95A7.525 7.525 0 0 0 28 20.475V7.525A7.525 7.525 0 0 0 20.475 0Z",
    fill: "#42BCF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.017 12.25H15.75V8.983c0-.968-.782-1.75-1.75-1.75s-1.75.782-1.75 1.75v3.267H8.983c-.968 0-1.75.782-1.75 1.75s.782 1.75 1.75 1.75h3.267v3.267c0 .968.782 1.75 1.75 1.75s1.75-.782 1.75-1.75V15.75h3.267c.968 0 1.75-.782 1.75-1.75s-.782-1.75-1.75-1.75Z",
    fill: "#CDF0FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lobby_create_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgLobbyCreate;